<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Account Type" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-banking-account-type-form [accountType]="accountType" *ngIf="accountType"></app-banking-account-type-form>
        </form>
      </div>
    </section>
  </div>
</div>
